export default __webpack_public_path__ + "static/1259-18e4b6dfc8e946006d897afc255ea06c.gif";